import { useState, useEffect } from "react";
import SecondaryNav from "../../../Navbar/SecondaryNav/SecondaryNav";
import SearchBar from "../../../Searchbar/Searchbar";
import axios from "axios";
import "./Educators.css";
import Navbar from "../../../Navbar/Navbar";
import Footer from "../../../Footer/Footer";

const Educators = () => {
  const [EducatorsData, setEducatorsData] = useState([]);

  useEffect(() => {
    axios.get('/api/educators/')
      .then(response => {
        setEducatorsData(response.data);
      })
      .catch(error => {
        alert("error");
        console.error('Error fetching Educators data:', error);
      });
  }, []);


  return (
    <>
    <Navbar />
      <SecondaryNav />
      <div className="educators-page">
        <h2 className="title1">Core Faculty</h2>
        <div className="lead-search">
          <SearchBar />
        </div>
        <div className="card-list">
          {EducatorsData.map((item, index) => (
            <Card key={index} item={item} />
          ))}
        </div>
        <div className="dummy"></div>
      </div>
      <Footer />
    </>
  );
};

const Card = ({ item }) => {
  const [Mouseon, setMouseState] = useState(false);

  const handleMouseEnter = (event) => {
    const elements = document.getElementsByClassName("image");
    for (const element of elements) {
      element.classList.add("overlay");
    }
    event.target.classList.remove("overlay");
  };

  const handleMouseLeave = (event) => {
    const elements = document.getElementsByClassName("image");
    for (const element of elements) {
      element.classList.remove("overlay");
    }
  };

  const renderSocial = (val) => {
    if (val) {
      if (val.includes("facebook.com")) {
        return "Facebook";
      } else if (val.includes("instagram.com")) {
        return "Instagram";
      } else if (val.includes("github.com")) {
        return "Github";
      } else if (val.includes("gitlab.com")) {
        return "Gitlab";
      } else if (val.includes("twitter.com")) {
        return "X/Twitter";
      } else {
        return "Social Media";
      }
    }
  };


  return (
    <div
      className="card-lead"
      onMouseOver={() => {
        setMouseState(true);
      }}
      onMouseOut={() => {
        setMouseState(false);
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img className="image" src={item.Picture} alt={item.Name} />
      <div className={Mouseon ? "on" : "off"}>
        <h4 className="profile-name">Name: {item.Name}</h4>
        <h4 className="profile-position">Position: {item.Title}</h4>
        <h4 className="profile-year">Year: {item.Year}</h4>
        <p className="profile-text">{item.Info}</p>
        <div className="profile-socials">
          {item.Social_Media_URL_1 && <a href={item.Social_Media_URL_1} target={"_blank"}>
            {renderSocial(item.Social_Media_URL_1)}
          </a>}
        </div>
        <div className="profile-socials">
          {item.Social_Media_URL_2 && <a href={item.Social_Media_URL_2} target={"_blank"}>
            {renderSocial(item.Social_Media_URL_2)}
          </a>}
        </div>
      </div>
    </div>
  );
};


export default Educators;
